<template>
  <modal
    name="confirm-dialog"
    width="80%"
    height="auto"
    :scrollable="true"
    style="z-index: 9999;"
  >
    <div class="p-5">
      <h2>{{ message }}</h2>
      <hr />
      <button class="mylisting-button secondary-button" @click="onReject()">
        {{ rejectLabel }}
      </button>
      <button
        class="mylisting-button danger-button"
        @click="onAccept()"
        style="float: right"
      >
        {{ acceptLabel }}
      </button>
    </div>
  </modal>
</template>
<script>
/* This component is used to show confirm dialog.
To show an confirm, call this.showConfirmDialog(confirmObject)
Structure of confirmObject:
{
    message: 'String',
    acceptLabel: 'String', <- This field is optional, if not set, use default: Yes
    rejectLabel: 'String',  <- This field is optional, if not set, use default: No
    onAcceptCallback: function reference <- This field is optional, if set, the function will be called after click accept button 
    onAcceptCallbackData: object <- This field is optional, it is parameter of onAcceptCallback function
}

*/
export default {
  name: "ConfirmDialog",
  data: function() {
    return {
      message: "",
      acceptLabel: "",
      rejectLabel: "",
      onAcceptCallback: null,
      onAcceptCallbackData: null
    };
  },
  methods: {
    onReject() {
      this.$modal.hide("confirm-dialog");
      this.showConfirmDialog(null);
    },
    onAccept() {
      console.log("on accept");
      this.$modal.hide("confirm-dialog");
      if (this.onAcceptCallback) {
        if (!this.onAcceptCallbackData) {
          this.onAcceptCallback();
        } else {
          this.onAcceptCallback(this.onAcceptCallbackData);
        }
      }
      this.showConfirmDialog(null);
    }
  },
  created() {
    this.$store.watch(
      state => state.dialogs.confirmDialog,
      value => {
        if (!value) {
          this.$modal.hide("confirm-dialog");
          this.showConfirmDialog(null);
        } else {
          if (this.isShow) {
            return;
          }
          this.message = value.message;
          if (!value.acceptLabel) {
            this.acceptLabel = "Yes";
          } else {
            this.acceptLabel = value.acceptLabel;
          }
          if (!value.rejectLabel) {
            this.rejectLabel = "No";
          } else {
            this.rejectLabel = value.rejectLabel;
          }
          this.onAcceptCallback = value.onAcceptCallback;
          this.onAcceptCallbackData = value.onAcceptCallbackData;
          this.$modal.show("confirm-dialog");
        }
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/ConfirmDialog.vue